import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20modern%20lifestyle%20accessories%20and%20fashion%20pieces%20on%20warm%20terrazzo%20surface%2C%20morning%20golden%20hour%20light%2C%20thoughtful%20composition%20with%20natural%20textures%2C%20editorial%20fashion%20photography%20with%20soft%20depth%20of%20field&width=1800&height=1200&seq=hero-bg-main-v2&orientation=landscape&nocache=true)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-background-50/85 via-background-50/70 to-accent-100/30"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 border border-background-200 text-foreground-700 text-xs font-medium mb-6">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                Guida Aggiornata 2026
              </span>

              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
                <span className="font-heading italic font-normal text-foreground-500">{t('hero.title_line1')}</span>
                <br />
                {t('hero.title_line2')}
                <br />
                {t('hero.title_line3')}
              </h1>

              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
                {t('hero.welcome')}
              </p>
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
                {t('hero.desc1')}
              </p>
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
                {t('hero.desc2')}
              </p>

              <ul className="text-sm text-foreground-600 space-y-2 mb-8 max-w-xl mx-auto lg:mx-0 text-left">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet1')}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet2')}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet3')}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet4')}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet5')}
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-500"></i> {t('hero.bullet6')}
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <Link
                  to="/guida-itaobuy-sheet-2026"
                  className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  {t('cta.scopri_guida')}
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-8 py-3.5 rounded-full text-primary-500 text-sm font-semibold underline underline-offset-4 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t('cta.come_funziona')}
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <div className="relative">
                <div className="rounded-[24px] overflow-hidden p-5 bg-background-50/60 backdrop-blur-sm">
                  <img
                    src="https://readdy.ai/api/search-image?query=Curated%20selection%20of%20minimalist%20fashion%20pieces%20in%20earthy%20terracotta%20and%20sage%20tones%20on%20light%20warm%20gray%20backdrop%2C%20soft%20directional%20light%2C%20artistic%20composition%20with%20organic%20shapes%2C%20editorial%20product%20photography%20with%20texture%20emphasis&width=800&height=900&seq=hero-product-main-v2&orientation=portrait&nocache=true"
                    alt="Itaobuy Spreadsheet prodotti"
                    className="w-full h-auto rounded-[18px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-14">
            <div className="rounded-[20px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Panoramic%20display%20of%20diverse%20fashion%20and%20lifestyle%20products%20in%20warm%20earth%20tones%20on%20light%20oak%20surface%2C%20soft%20natural%20side%20lighting%2C%20clean%20editorial%20composition%20with%20shallow%20depth%2C%20minimalist%20commercial%20photography&width=1800&height=500&seq=hero-banner-bottom-v2&orientation=landscape&nocache=true"
                alt="Itaobuy Spreadsheet collezione prodotti"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}